/**
 * v3.21-1832 — CF360 transfer visibility.
 * Renders from the backend `client.cf360_transfer` block so a client
 * moved to CreditForward360 is obvious and traceable everywhere.
 */
import { ArrowRightLeft } from 'lucide-react';

const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso).slice(0, 10) : d.toLocaleDateString();
};

export const CF360TransferBadge = ({ transfer, testId }) => {
  if (!transfer?.in_cf360 || transfer.kind !== 'company_bucket') return null;
  return (
    <span
      data-testid={testId || 'cf360-transfer-badge'}
      title={`Transferred to CreditForward360${transfer.reason ? ` — ${transfer.reason}` : ''}${transfer.original_company_name ? ` (from ${transfer.original_company_name})` : ''}`}
      className="inline-flex items-center gap-1 rounded-full bg-orange-100 text-orange-900 border border-orange-400 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide leading-none"
    >
      <ArrowRightLeft className="h-3 w-3" />
      CF360
    </span>
  );
};

const Row = ({ label, value, testId }) => (
  <div className="flex gap-1">
    <span className="font-medium">{label}:</span>
    <span data-testid={testId}>{value || '—'}</span>
  </div>
);

export const CF360TransferBanner = ({ client }) => {
  const t = client?.cf360_transfer;
  if (!t?.in_cf360 || t.kind !== 'company_bucket') return null;
  const repLabel = t.original_rep_source === 'original_company_director'
    ? `${t.original_rep_name} (company director)` : t.original_rep_name;
  return (
    <div data-testid="cf360-transfer-banner" className="border-l-4 border-orange-500 bg-orange-50 text-orange-950 rounded-md p-4 mb-4 shadow-sm">
      <div className="flex items-start gap-3">
        <ArrowRightLeft className="h-5 w-5 text-orange-700 mt-0.5 shrink-0" />
        <div className="flex-1">
          <div className="font-semibold text-sm">Transferred to CreditForward360</div>
          <div className="text-xs mt-1 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-0.5">
            <Row label="Transfer date" value={fmtDate(t.transferred_at)} testId="cf360-transfer-date" />
            <Row label="Transfer reason" value={t.reason} testId="cf360-transfer-reason" />
            <Row label="Original company" value={t.original_company_name} testId="cf360-original-company" />
            <Row label="Original rep" value={repLabel} testId="cf360-original-rep" />
            <Row label="Current company" value={t.current_company_name} testId="cf360-current-company" />
            {t.transferred_by && <Row label="Transferred by" value={t.transferred_by} testId="cf360-transferred-by" />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CF360TransferBanner;
